module.exports = "/_next/static/images/buyers_8_ru-2b7688481c5a78bb96ca6569d67c312f.png";